// extracted by mini-css-extract-plugin
module.exports = {"container":"Footer_container__3nRUm","legal":"Footer_legal__bSYbY"};